module.exports = __webpack_public_path__ + "static/caddy-life-1009b867bebcc805f90cde85465161ac.png";